/**
 * 491123 / 493427 — duração da animação de "linha saindo" (esmaece virando vermelho), usada pela
 * cesta de produtos e pela exclusão de item na grade do orçamento.
 *
 * É o tempo que o `setTimeout` espera antes de remover o dado de verdade, para a animação CSS
 * conseguir rodar até o fim antes de o elemento desmontar. Tem de bater com `$duracao-remocao-linha`
 * de `estilos/_animacoes.scss` — mexer num lugar exige mexer no outro (SCSS e TS não compartilham
 * constante).
 */
export const DURACAO_ANIMACAO_REMOCAO_MS = 300

export default DURACAO_ANIMACAO_REMOCAO_MS
